import script from "./VModalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./VModalDetail.vue?vue&type=script&setup=true&lang=js"

import "./VModalDetail.vue?vue&type=style&index=0&id=774dd594&lang=css&scoped=true"

import exportComponent from "/Users/dioratar/Documents/_project/omni/repo/emetrai/event-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774dd594"]])

export default __exports__